import type { CompassLocale } from "@circleco/compass/locale/types";

import { notifyBugsnag } from "@/react/helpers/bugsnagHelpers";
import { getCurrentCircleLocale } from "@/react/helpers/localeHelpers";
import type { CircleLocale } from "@/react/types/CircleLocale";

// English is omitted because Compass defaults to en-US without a locale.
const compassLocaleLoaders: Record<
  Exclude<CircleLocale, "en">,
  () => Promise<CompassLocale>
> = {
  pt: () =>
    import(
      /* webpackChunkName: "compass_locale_pt_br" */ "@circleco/compass/locale/pt-BR"
    ).then(module => module.ptBR),
  "pt-PT": () =>
    import(
      /* webpackChunkName: "compass_locale_pt" */ "@circleco/compass/locale/pt"
    ).then(module => module.pt),
  es: () =>
    import(
      /* webpackChunkName: "compass_locale_es" */ "@circleco/compass/locale/es"
    ).then(module => module.es),
  fr: () =>
    import(
      /* webpackChunkName: "compass_locale_fr" */ "@circleco/compass/locale/fr"
    ).then(module => module.fr),
  it: () =>
    import(
      /* webpackChunkName: "compass_locale_it" */ "@circleco/compass/locale/it"
    ).then(module => module.it),
  de: () =>
    import(
      /* webpackChunkName: "compass_locale_de" */ "@circleco/compass/locale/de"
    ).then(module => module.de),
};

export const loadCompassLocale = async (): Promise<
  CompassLocale | undefined
> => {
  const locale = getCurrentCircleLocale();
  if (locale === "en") return undefined;

  try {
    return await compassLocaleLoaders[locale]();
  } catch (error: unknown) {
    notifyBugsnag(error instanceof Error ? error : new Error(String(error)));
    return undefined;
  }
};
